export const profile = {
	name: 'Raven Matthew L. Capulong',
	shortName: 'Raven',
	handle: 'atthmew',
	role: 'Junior Software Engineer II',
	company: 'GoRated Laboratory Inc. (ChatGenie)',
	email: 'ravenmcapulong@gmail.com',
	phone: '09762880344',
	discord: '_rvnm',
	cv: '/others/capulongResume.pdf',
	links: {
		facebook: 'https://www.facebook.com/atthmew',
		instagram: 'https://www.instagram.com/atthmew/',
		github: 'https://github.com/atthmew',
		linkedin: 'https://www.linkedin.com/in/atthmew/',
	},
};
